<section data-component="primary-banner" class="row justify-content-center align-items-center" #primaryBanner>
	<div *ngIf = "isAdEnabled; else dynamicAd" class="static-offer">
		<flex-seo></flex-seo>	
	</div>
	<ng-template #dynamicAd>
		<div class="col-md-12 p-0 text-center fn-dmar" data-dfp-slotName="PRIMARY_SIGN_ON" id="PRIMARY_SIGN_ON">
		</div>
	</ng-template>
</section>
